<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-text>
            <v-layout row>
              <v-flex xs4>
                <v-card elevation=5>
                  <v-card-title>
                    <div>
                      <div class="headline">Agreements Reached</div>
                    </div>
                  </v-card-title>
                  <v-card-text class="text-xs-right">
                    <div class="flex title">
                      {{ agreementReached }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card elevation=5>
                  <v-card-title>
                    <div>
                      <div class="headline">Total Annotation Effort</div>
                    </div>
                  </v-card-title>
                  <v-card-text class="text-xs-right">
                    <div class="flex title">
                      {{ allAnnotationEffort }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card elevation=5>
                  <v-card-title>
                    <div>
                      <div class="headline">Last Calculated Date</div>
                    </div>
                  </v-card-title>
                  <v-card-text class="text-xs-right">
                    <div class="flex title">
                      {{ lastCalculatedDate | formatDate}}
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-card elevation=3>
                  <v-toolbar>
                    <div class="headline">Task Status</div>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-data-table
                  hide-actions
                  :headers="statisticsTableHeaders"
                  :items="taskStats">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.annotationTask }}</td>
                      <td>{{ props.item.annotator }}</td>
                      <td>{{ props.item.annotationCount }}</td>
                      <td>{{ props.item.targetCount }}</td>
                      <td v-for="(annotation, i) in props.item.annotations" :key="i">
                        {{ annotation.count }}
                      </td>
                      <td>{{ annotationStatusCollection[props.item.status] }}</td>
                      <td>{{ props.item.createdDate | formatDate }}</td>
                      <td>{{ props.item.expireDate | formatDate }}</td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row v-if="agreementLevel > 1">
              <v-flex xs12>
                <v-card elevation=3>
                  <v-toolbar>
                    <div class="headline">Agreement Matrix (Partial vs Full Matches)</div>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-data-table
                  hide-actions
                  :headers="agreementMatrixHeaders"
                  :items="agreementMatrix">
                    <template slot="items" slot-scope="props">
                      <td> {{ annotators[props.index] }} </td>
                      <td v-for="(agreement, i) in props.item" :key="i">
                        {{ agreement }}
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row v-if="agreementLevel > 1">
              <v-flex xs12>
                <v-card elevation=3>
                  <v-toolbar>
                    <div class="headline">Agreements per Label (Ratio vs Positive Count)</div>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-data-table
                  hide-actions
                  :headers="labelAgreementsHeaders"
                  :items="labelAgreements">
                    <template slot="items" slot-scope="props">
                      <td v-for="(agreement, i) in props.item" :key="i">
                        {{ agreement }}
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'annotation-work-statistics-item',
  props: {
    annotationWorkId: {
      type: String,
      required: true
    }
  },
  created () {
    this.fetchAnnotationWorkStatistics()
  },
  data () {
    return {
      agreementReached: undefined,
      allAnnotationEffort: undefined,
      lastCalculatedDate: undefined,
      agreementMatrix: [],
      labelAgreements: [],
      annotators: [],
      taskStats: [],
      saveLoading: false,
      statisticsTableHeaders: [
        {text: 'Annotation Task', sortable: true, value: 'id'},
        {text: 'Annotator', sortable: true, value: 'annotator'},
        {text: 'Annotation Count', sortable: false, value: 'dataset'},
        {text: 'Target Count', sortable: false, value: 'topicModel'},
        {text: 'Status', sortable: false, value: 'status'},
        {text: 'Created Date', sortable: true, value: 'createdDate'},
        {text: 'Expire Date', sortable: true, value: 'expireDate'}
      ]
    }
  },
  computed: {
    ...mapState({
      annotationStatusCollection: state => state.configurations.annotationStatusDictionary
    }),
    agreementMatrixHeaders () {
      let headers = [{text: '', sortable: false, value: 'empty'}]
      headers = headers.concat(this.annotators.map((a) => {
        return {text: a, sortable: false, value: 'a'}
      }))
      return headers
    },
    labelAgreementsHeaders () {
      var arr = [{text: 'Label', sortable: true, value: 'a'}]
      var i
      for (i = 0; i < this.annotators.length - 1; i++) {
        var j
        for (j = i + 1; j < this.annotators.length; j++) {
          let lhs = this.annotators[i]
          let rhs = this.annotators[j]
          let headerText = lhs.concat(' - ').concat(rhs)
          arr.push({text: headerText, sortable: false, value: headerText})
        }
      }
      return arr
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchAnnotationWorkStatistics () {
      this.setLoader({
        loading: true
      })
      this.axios.get(`/annotation-works/${this.annotationWorkId}/stats`)
        .then(result => {
          const item = result.data
          this.agreementReached = item.agreement_reached
          this.allAnnotationEffort = item.all_annotation_effort
          this.lastCalculatedDate = item.last_calculated_date
          this.agreementLevel = item.agreement_level
          if (item.user_stats && item.user_stats.length > 0) {
            const annotations = item.user_stats[0].annotations.map((a) => {
              return {text: a.label, sortable: false, value: a.label}
            })
            this.statisticsTableHeaders.splice(4, 0, ...annotations)
          }
          this.taskStats = item.user_stats.map((us) => {
            return {
              annotator: us.annotator,
              annotationTask: us.annotation_task,
              annotationCount: us.annotation_count,
              targetCount: us.target_count,
              status: us.status,
              createdDate: us.created_date,
              expireDate: us.expire_date,
              annotations: us.annotations
            }
          })
          this.annotators = item.agreement.annotators
          this.agreementMatrix = item.agreement.agreement
          this.labelAgreements = item.agreement.label_agreements
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  }
}
</script>

<style>

</style>
